
@switch (displayMode) {
  <!-- accordion -->
  @case ('accordion') {
    @if ((shareSvc.isMobileMode$ | async)) {
      <mat-accordion multi="true" displayMode="flat">
        @for (firstLevel of tree.nodes; track firstLevel) {
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              {{firstLevel.name}}
            </mat-expansion-panel-header>
            @if (firstLevel.children?.length) {
              @for (secondLevel of firstLevel.children; track secondLevel) {
                <ul class="tax-level-2">
                  <li class="menu-item">
                    <h2>{{secondLevel.name}}</h2>
                    @if (secondLevel.children?.length) {
                      <ul class="tax-level-3">
                        @for (thirdLevel of secondLevel.children; track thirdLevel) {
                          <li class="menu-item">
                            <a [routerLink]="[thirdLevel.url]" routerLinkActive="active-link">{{thirdLevel.name}}</a>
                          </li>
                        }
                      </ul>
                    }
                  </li>
                </ul>
              }
            }
          </mat-expansion-panel>
        }
      </mat-accordion>
    }
  }
  <!-- navbar -->
  @case ('navbar') {
    <div class="menu-wrapper" [class.menuOpened]="firstLevelInfo?.children?.length">
      <nav class="menu-navigation">
        <ul class="tax-level-1">
          @for (firstLevel of tree.nodes; track firstLevel; let i = $index) {
            <li class="menu-item">
              <button (click)="showContent(firstLevel)"
                aria-haspopup="true"
                [attr.aria-expanded]="triggerExpanded == firstLevel.id"
                [attr.aria-controls]="'menu-'+firstLevel.id">
                {{firstLevel.name}}
              </button>
            </li>
          }
        </ul>
      </nav>
      @if (firstLevelInfo?.children?.length) {
        <div class="menu-content" [id]="'menu-'+firstLevelInfo.id">
          @for (secondLevel of firstLevelInfo.children; track secondLevel) {
            <ul class="tax-level-2">
              <li class="menu-item">
                <h2>{{secondLevel.name}}</h2>
                @if (secondLevel.children?.length) {
                  <ul class="tax-level-3">
                    @for (thirdLevel of secondLevel.children; track thirdLevel) {
                      <li class="menu-item">
                        <a [routerLink]="[thirdLevel.url]" routerLinkActive="active-link">{{thirdLevel.name}}</a>
                      </li>
                    }
                  </ul>
                }
              </li>
            </ul>
          }
        </div>
      }
    </div>
  }
}
